import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-text-block-citation',
  templateUrl: './text-block-citation.component.html',
  styleUrls: ['./text-block-citation.component.scss']
})
export class TextBlockCitationComponent implements OnInit {

  @Input()
  text: {content: string; author: string};

  constructor() { }

  ngOnInit() {
  }

}